import { render, staticRenderFns } from "./pallete.vue?vue&type=template&id=480b3198"
import script from "./pallete.vue?vue&type=script&lang=ts"
export * from "./pallete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports